<template>
  <div class="row mb-25 pb-18 align-items-end br-1 gx-0">
    <div class="col-md-6">
      <h4 class="mb-0">{{ translatedTitle }}</h4>
    </div>
    <div class="col-md-6">
      <ul class="breadcrumb-menu list-style lh-base text-md-end">
        <li v-if="showHome">
          <router-link to="/">{{ t('dashboard') }}</router-link>
        </li>
        <template v-if="items && items.length > 0">
          <li
            v-for="(item, index) in items"
            :key="`${item.label}-${index}`"
            :class="{ active: index === items.length - 1 }"
          >
            <router-link v-if="item.to && index < items.length - 1" :to="item.to">{{ t(item.label) }}</router-link>
            <span v-else>{{ t(item.label) }}</span>
          </li>
        </template>
        <template v-else-if="paths && paths.length > 0">
          <li v-for="(path, index) in paths" :key="index" :class="{ active: index === paths.length - 1 }">
            <router-link v-if="index < paths.length - 1" :to="'/'">{{ t(path) }}</router-link>
            <span v-else>{{ t(path) }}</span>
          </li>
        </template>
        <li v-else-if="pageTitle" class="active">{{ translatedTitle }}</li>
      </ul>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, computed, PropType } from "vue";
import { useI18n } from "vue-i18n";

type BreadcrumbItem = {
  label: string;
  to?: string;
};

export default defineComponent({
  name: "BreadcrumbMenu",
  props: {
    pageTitle: String,
    paths: Array as PropType<string[]>,
    items: Array as PropType<BreadcrumbItem[]>,
    showHome: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const translatedTitle = computed(() => t(props.pageTitle || ''));
    return {
      translatedTitle,
      t,
    };
  },
});
</script>

<style lang="scss" scoped>
.breadcrumb-menu {
  li {
    display: inline-block;
    position: relative;
    padding-right: 20px;
    font-size: 14px;
    font-weight: 500;
    &:after {
      position: absolute;
      top: -1px;
      right: 6px;
      content: "/";
      font-size: 14px;
      font-weight: 400;
    }
    &:last-child {
      padding-right: 0;
      &:after {
        display: none;
      }
    }
    a {
      color: var(--secondaryColor);
    }
  }
}

@media only screen and (max-width: 767px) {
  .breadcrumb-menu {
    margin-top: 10px;
  }
}
</style>
